import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearTransactions,
  getTransactions,
} from '../../../../actions/accounting/Transaction';
import { TRANSACTION_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { TRANSACTION_COLUMNS } from '../../../../config/columns';

export const Transactions = ({
  breadcrumbs,
  transactions,
  loading,
  dispatchGetTransactions,
  dispatchClearTransactions,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearTransactions();
    },
    [],
  );

  const data = transactions.get('content') || [];
  const pages = transactions.get('totalPages') || null;
  const defaultPageSize = transactions.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Transacciones"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: TRANSACTION_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetTransactions,
        loading,
        modelPath: TRANSACTION_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTransactions: getTransactions,
  dispatchClearTransactions: clearTransactions,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Transacciones',
      href: TRANSACTION_PATH,
    },
  ],
  transactions: AccountingUnit.Transaction.getIn(['all', 'content']),
  loading: AccountingUnit.Transaction.getIn(['all', 'loading']),
});

Transactions.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  transactions: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTransactions: PropTypes.func.isRequired,
  dispatchClearTransactions: PropTypes.func.isRequired,
};

Transactions.defaultProps = {
  transactions: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
